__turbopack_context__.v({
  "footerContactRow": "FooterSection-module__P6pp_G__footerContactRow",
  "footerDirectionsLink": "FooterSection-module__P6pp_G__footerDirectionsLink",
  "footerImage": "FooterSection-module__P6pp_G__footerImage",
  "footerPhoneLink": "FooterSection-module__P6pp_G__footerPhoneLink",
  "footerWrapper": "FooterSection-module__P6pp_G__footerWrapper",
  "hoursLabel": "FooterSection-module__P6pp_G__hoursLabel",
  "hoursLabelSpaced": "FooterSection-module__P6pp_G__hoursLabelSpaced",
  "hoursMuted": "FooterSection-module__P6pp_G__hoursMuted",
  "hoursNote": "FooterSection-module__P6pp_G__hoursNote",
  "hoursPrimary": "FooterSection-module__P6pp_G__hoursPrimary",
  "imageContainer": "FooterSection-module__P6pp_G__imageContainer",
  "imageRow": "FooterSection-module__P6pp_G__imageRow",
  "infoBlock": "FooterSection-module__P6pp_G__infoBlock",
  "infoColumn": "FooterSection-module__P6pp_G__infoColumn",
  "infoText": "FooterSection-module__P6pp_G__infoText",
  "infoTitle": "FooterSection-module__P6pp_G__infoTitle",
});
